import observeOptionSelected from './observeOptionSelected';
import observeSelectValue from './observeSelectValue';

// ----------------------------------------------------------------------------

export type TypeObserveSelectConfig = {
    fnChange?: (value: string | string[]) => void;
    fnSelected?: (selected: boolean) => void;
};

// ----------------------------------------------------------------------------

function observeSelect(element: HTMLSelectElement, config: TypeObserveSelectConfig = {}): MutationObserver {
    // Observe changes to select.value (single or multiple)
    observeSelectValue(element, {
        fnChange: function (value): any {
            if (typeof config.fnChange === 'function') {
                config.fnChange.call(element, value);
            }
        },
    });

    // Observe options selected changes in any case (single or multiple)
    function updateAllOptions(): void {
        for (const option of element.options) {
            observeOptionSelected(option, {
                fnSelected: function (value): any {
                    if (typeof config.fnSelected === 'function') {
                        config.fnSelected.call(option, value);
                    }
                },
            });
        }
    }

    updateAllOptions();

    // Observe additions/removals of options dynamically (both single and multiple)
    const observer = new MutationObserver((): any => {
        updateAllOptions();
    });

    observer.observe(element, { childList: true });

    return observer;
}

// ----------------------------------------------------------------------------

export default observeSelect;
